// js/sections/countdown-timer.js
var CountdownTimer = class extends HTMLElement {
  connectedCallback() {
    
    const _this = this;

    var themeVariables = JSON.parse(document.querySelector("[data-theme-information]").innerHTML)
  
    let countdown_timerEl = this.querySelector(".countdown_timer");
    if(countdown_timerEl) {
      const dateStr = _this.getAttribute('data-time');
      const use_short_style =  (_this.getAttribute('data-use_short_style') === 'true'); 
      
      let countDownDate = new Date(dateStr).getTime();
      if(dateStr == '0') {
         countDownDate = new Date().setHours(23,59,59,999);
      }

      const timerDaysElem = this.querySelector('.timer-days .timer-value');
      const timerDaysLabelElem = this.querySelector('.timer-days .timer-label');
      
      const timerHoursElem = this.querySelector('.timer-hours .timer-value');
       const timerHoursLabelElem = this.querySelector('.timer-hours .timer-label');
      
      const timerMinutesElem = this.querySelector('.timer-minutes .timer-value');
      const timerMinutesLabelElem = this.querySelector('.timer-minutes .timer-label');
      
      const timerSecondsElem = this.querySelector('.timer-seconds .timer-value');
      const timerSecondsLabelElem = this.querySelector('.timer-seconds .timer-label');
      

      let x = setInterval(function() {
        let now = new Date().getTime();
        let distance = countDownDate - now;
        
        if(distance <= 0) {
          
            clearInterval(x);
            if(_this) {
              _this.style.display = 'none';

              if(_this.closest('.richtext_timer_block')) {
                _this.closest('.richtext_timer_block').style.display = 'none';
              }
                       if(_this.closest('.offer')) {
                _this.closest('.offer').style.display = 'none';
              }

              
            }
          
        }


        if(distance >= 0) {
          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);



          if(timerDaysLabelElem) {
            timerDaysLabelElem.innerHTML = themeVariables.locale.timer_days;
          }

          if(timerHoursLabelElem) {
            timerHoursLabelElem.innerHTML = themeVariables.locale.timer_hours;
          }

          if(timerMinutesLabelElem) {
            timerMinutesLabelElem.innerHTML = themeVariables.locale.timer_minutes;
          }


          if(timerSecondsLabelElem) {
            timerSecondsLabelElem.innerHTML = themeVariables.locale.timer_seconds;
          }
          
          
          
          if(days < 10) {
            days = "0"+days;
          }
          if(hours < 10) {
            hours = "0"+hours;
          }
          if(minutes < 10) {
            minutes = "0"+minutes;
          }
          if(seconds < 10) {
            seconds = "0"+seconds;
          }

        

          timerDaysElem.innerHTML = days;
          timerHoursElem.innerHTML = hours;
          timerMinutesElem.innerHTML = minutes;
          timerSecondsElem.innerHTML = seconds;
        }
      },1000);

    }

  }

};
if (!window.customElements.get("countdown-timer")) {
  window.customElements.define("countdown-timer", CountdownTimer);
}

document.addEventListener("DOMContentLoaded", function(event) { 
  var productSocialProofingFirst = document.querySelector('.main-image-slider-social-proofing-item-first');
  var productSocialProofingSecond = document.querySelector('.main-image-slider-social-proofing-item-second');
  var productSocialProofingWrapper = document.querySelector('.main-image-slider-social-proofing');
  if (productSocialProofingFirst != null) {
    setTimeout(function() {
      if (productSocialProofingWrapper != null) {
        productSocialProofingWrapper.classList.add('is-active');
      }
      productSocialProofingFirst.classList.add('is-active');
      setTimeout(function() {
        if (productSocialProofingWrapper != null && productSocialProofingSecond == null) {
          productSocialProofingWrapper.classList.remove('is-active');
        }
        productSocialProofingFirst.classList.remove('is-active');
      }, 5000);
    }, 1000);
  }

  if (productSocialProofingSecond != null) {
    setTimeout(function() {
      if (productSocialProofingWrapper != null) {
        productSocialProofingWrapper.classList.add('is-active');
      }
      productSocialProofingSecond.classList.add('is-active');
      setTimeout(function() {
        if (productSocialProofingWrapper != null) {
          productSocialProofingWrapper.classList.remove('is-active');
        }
        productSocialProofingSecond.classList.remove('is-active');
      }, 5000);
    }, 2000);
  }

  var productPopupsTriggers = document.querySelectorAll('.product-popup-trigger');
  if (productPopupsTriggers.length) {
    productPopupsTriggers.forEach(function (item) {
      item.addEventListener("click", function() { 
        var itemId = this.getAttribute('data-id');
        var itemPopup = document.querySelector('.modal-slidein[data-id="' + itemId + '"]');
        if (itemPopup != null) {
          itemPopup.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      });
    });
  }

  var productPopupsClose = document.querySelectorAll('.modal-slidein__close-button');
  if (productPopupsClose.length) {
    productPopupsClose.forEach(function (item) {
      item.addEventListener("click", function() {
        this.closest('.modal-slidein').classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  var productPopups = document.querySelectorAll('.modal-slidein');
  if (productPopups.length) {
    productPopups.forEach(function (item) {
      item.addEventListener("click", function(e) {
        if (!e.target.closest('.modal-slidein__inner')) {
          this.closest('.modal-slidein').classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    });
  }

  var productTabIngredientsAccoButtons = document.querySelectorAll('.product-tabs__ingredients-title-all');
  if (productTabIngredientsAccoButtons.length) {
    productTabIngredientsAccoButtons.forEach(function (item) {
      item.addEventListener("click", function(e) {
        this.classList.toggle("active");
 
        var accordionPanel = this.closest('.rte').querySelector('.product-tabs__ingredients-title-all-body');
        if (accordionPanel != null) {
          if (accordionPanel.style.maxHeight) {
            accordionPanel.style.maxHeight = null;
          } else {
            accordionPanel.style.maxHeight = accordionPanel.scrollHeight + "px";
          }
        }
      });
    });
  }
});


// js/sections/shipment-timer.js
var shipmentCountdown = class extends HTMLElement {
  connectedCallback() {
    
    const _this = this;  
      
      let countDownDate = new Date();
      let dayOfTheWeek = countDownDate.getUTCDay();
      if(dayOfTheWeek == 0 || dayOfTheWeek == 6){
        return;
      }
      let countDownDateMileseconds = new Date().getTime();
     // let countDownDateOffset = countDownDate.getTimezoneOffset();
     // let countDownDateOffsetMileseconds = countDownDateOffset * 60 * 1000;
      let currentHours = Math.floor((countDownDateMileseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let countdownSpan = this.querySelector("span");

      if(currentHours >=0 && currentHours < 14){
         _this.style.display = 'block';  

         if(countdownSpan){
          let endDate = new Date().setUTCHours(13,59,59,999);
          let distance = endDate - countDownDateMileseconds;
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if(hours < 10 && hours > 0) {
            hours = "0"+hours;
          }
          if(minutes < 10 && minutes > 0) {
            minutes = "0"+minutes;
          }
          if(seconds < 10 && seconds > 0) {
            seconds = "0"+seconds;
          }
          
          let countDownString = "";
          if(hours > 0){
            countDownString += hours + " hrs ";
          }
           if(minutes > 0 || hours > 0){
            countDownString += minutes + " mins ";
          }
           if(seconds > 0 || hours > 0 || minutes > 0){
            countDownString += seconds + " secs";
          }
          countdownSpan.innerHTML = countDownString;

         }
      //debugger;

      let x = setInterval(function() {
            let dayOfTheWeek = new Date().getUTCDay();
            if(dayOfTheWeek == 0 || dayOfTheWeek == 6){
               _this.style.display = 'none';    
              return;
            }
          let countDownDateMileseconds = new Date().getTime();
          let currentHours = Math.floor((countDownDateMileseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
         if(currentHours >=0 && currentHours < 14){
          let endDate = new Date().setUTCHours(13,59,59,999);
          let distance = endDate - countDownDateMileseconds;
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);

         if(hours < 10 && hours > 0) {
            hours = "0"+hours;
          }
          if(minutes < 10 && minutes > 0) {
            minutes = "0"+minutes;
          }
          if(seconds < 10 && seconds > 0) {
            seconds = "0"+seconds;
          }
          
          let countDownString = "";
           if(hours > 0){
            countDownString += hours + " hrs ";
          }
           if(minutes > 0 || hours > 0){
            countDownString += minutes + " mins ";
          }
           if(seconds > 0 || hours > 0 || minutes > 0){
            countDownString += seconds + " secs";
          }
          countdownSpan.innerHTML = countDownString;

        }else{
           _this.style.display = 'none';    
        }
      },1000);
    }
  }

};
if (!window.customElements.get("shipment-countdown")) {
  window.customElements.define("shipment-countdown", shipmentCountdown);
}







